import './styles.scss';
import React from 'react';
import { Col } from 'reactstrap';

type ListViewItemProps = {
  className?: string;
  col?: boolean;
};

const ListViewItem: React.FC<ListViewItemProps> = ({
  className,
  children,
  col = true,
}) => {
  if (!col) {
    return (
      <div className={`list-view-item ${className} mb-4 px-2`}>
        <div className="list-view-item-inner">{children}</div>
      </div>
    );
  }

  return (
    // <Col className={`list-view-item ${className}`} {...colOptions}>
    <Col className={`list-view-item ${className} mb-4 px-2`}>
      <div className="list-view-item-inner">{children}</div>
    </Col>
  );
};

export default ListViewItem;
